import React, { useEffect, useState } from "react";
import { storyblokEditable } from "@storyblok/react";
import { PressTimelineModel } from "./PressTimelineModel";
import { themeService } from "../../core/NotificationStripNav/ThemeService";
import { Theme } from "../../core/Models/CustomSiteConfigModel";
import { ListPanelEntityModel } from "../../product/ListPanel/ListPanelModel";
import SupportUtils from "../../support/SupportUtils";
import PressTimelineItem from "./PressTimelineItem/PressTimelineItem";
import { PageModel } from "../../core/Models/PageModel";
import { ArticleModel } from "../Article/ArticleModel";

import "./PressTimeline.css";
import { useNavigate } from "react-router-dom";
import Hyperlink from "../../core/Hyperlink/Hyperlink";

const PressTimeline: React.FC<{ blok: PressTimelineModel }> = ({ blok }) => {
  const [theme, setTheme] = useState<Theme | null>(themeService.getTheme());
  const [selectedYear, setSelectedYear] = useState<number>(0);
  const [data, setData] = useState<ListPanelEntityModel[]>([]);
  const [filteredData, setFilteredData] = useState<ListPanelEntityModel[]>([]);

  const navigate = useNavigate();

  const sortedYears = blok.years?.map(Number).sort((a, b) => b - a);
  const maxYear = Math.max(...sortedYears);

  useEffect(() => {
    SupportUtils.getCachedOrStoryblokSearch(
      "",
      undefined,
      null,
      "Press",
      null,
      undefined
    )
      .then((response: any) => {
        const data = response.data?.story || response.data?.stories;
        setData(
          data?.filter(
            (x: ListPanelEntityModel) =>
              x.full_slug?.startsWith("articles/news/") ||
              x.full_slug?.startsWith("articles/press/")
          )
        );
      })
      .catch((error) => {
        if (error.status === 404) {
          navigate("/404");
        } else if (error.status === 500) {
          navigate("/500");
        }
      });

    const unsubscribe = themeService.subscribe(setTheme);
    return () => unsubscribe();
  }, [navigate]);

  useEffect(() => {
    setSelectedYear(maxYear);
  }, [maxYear]);

  useEffect(() => {
    const fData = data.filter(
      (d) =>
        d.content &&
        (d.content as PageModel).body &&
        (d.content as PageModel)?.body &&
        ((d.content as PageModel)?.body?.[0] as ArticleModel).publicationYear &&
        new Date(
          ((d.content as PageModel)?.body?.[0] as ArticleModel).publicationYear
        ).getFullYear() &&
        new Date(
          ((d.content as PageModel)?.body?.[0] as ArticleModel).publicationYear
        ).getFullYear() === selectedYear
    );
    setFilteredData(fData);
  }, [selectedYear, data]);

  return (
    <div
      {...storyblokEditable(blok)}
      className={`press-timeline`}
      style={{ backgroundColor: theme?.panelColour, color: theme?.textColor }}
    >
      <div className="container">
        <div className="container-content">
          <div className="title">{blok.title} </div>
          <div className="standfirst-container">
            <div className="standfirst">{blok.standfirst}</div>
            <div className="standfirst-link">
              {blok.link && blok.link.length > 0 && (
                <Hyperlink blok={blok.link[0]}></Hyperlink>
              )}
            </div>
          </div>
          <div className="years" style={{ borderColor: theme?.textColor }}>
            {sortedYears?.map((year) => (
              <div
                key={`years-item-${year}`}
                className={`year ${year === selectedYear ? "selected" : ""}`}
                onClick={() => {
                  setSelectedYear(year);
                }}
              >
                {year}
              </div>
            ))}
          </div>
          <div className="press-items">
            {filteredData &&
              filteredData.map((article) => (
                <PressTimelineItem
                  blok={article}
                  key={article.uuid}
                ></PressTimelineItem>
              ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PressTimeline;
